import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js/instance/sort';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js/instance/find';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import React__default, { useState } from 'react';
import { hooks } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import useEvent from 'react-use/lib/useEvent';
import '../lazy-image/legacy-lazy-image/index.js';
import { SquareLazyImage } from '../lazy-image/lazy-image/index.js';
import '../scrollable/legacy-scrollable/index.js';
import { Scrollable } from '../scrollable/scrollable/index.js';
import { SmallEmotesPicker, BigEmotesPicker, TextEmotesPicker } from './emotes-picker.js';
import { EEmotePackageType } from './enum.js';
import { EPackageState, useEmotes, appendEmotePrefix } from './hooks/use-emotes.js';

var _emoteListMap;
var emoteListMap = (_emoteListMap = {}, _defineProperty(_emoteListMap, EEmotePackageType.Small, SmallEmotesPicker), _defineProperty(_emoteListMap, EEmotePackageType.Big, BigEmotesPicker), _defineProperty(_emoteListMap, EEmotePackageType.Text, TextEmotesPicker), _emoteListMap);

function recordLastUsedPackage(userId, activePackageId) {
  sessionStorage.setItem("maoer-".concat(userId, ":lastUsedEmotePackage"), activePackageId.toString());
}

function getLastUsedPackage(userId) {
  var activePackageId = sessionStorage.getItem("maoer-".concat(userId, ":lastUsedEmotePackage"));
  return activePackageId ? _parseInt(activePackageId) : null;
}

var VISIBLE_STATE_IN_PICKER = [EPackageState.Available, EPackageState.Locked];
var EmotePanel = function EmotePanel(props) {
  var className = props.className;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeEmotePackageId = _useState2[0],
      setActiveEmotePackageId = _useState2[1];

  var _useEmotes = useEmotes(),
      emoteData = _useEmotes.data,
      emotePackagesState = _useEmotes.emotePackagesState;

  var rootRef = React__default.useRef(null);

  var _hooks$useUser = hooks.useUser(),
      _hooks$useUser2 = _slicedToArray(_hooks$useUser, 1),
      currentUser = _hooks$useUser2[0];

  var sortedEmotePackages = React__default.useMemo(function () {
    var _context, _context2;

    if (!emoteData) {
      return [];
    } // 表情包的 order 不存在或者为 0，需要隐藏


    return _sortInstanceProperty(_context = _filterInstanceProperty(_context2 = emoteData.packages).call(_context2, function (_ref) {
      var order = _ref.order,
          id = _ref.id;
      return order && order !== 0 && _includesInstanceProperty(VISIBLE_STATE_IN_PICKER).call(VISIBLE_STATE_IN_PICKER, emotePackagesState[id]);
    })).call(_context, function (a, b) {
      return a.order - b.order;
    });
  }, [emoteData, emotePackagesState]);
  React__default.useEffect(function () {
    if (!emoteData || !currentUser) {
      return;
    }

    var lastUsedPackageId = getLastUsedPackage(currentUser.id);
    setActiveEmotePackageId(lastUsedPackageId !== null && lastUsedPackageId !== void 0 ? lastUsedPackageId : emoteData.focus_package_id);
  }, [emoteData, currentUser]);
  var activeEmotePackage = React__default.useMemo(function () {
    var _sortedEmotePackages$;

    if (!activeEmotePackageId) {
      return sortedEmotePackages[0];
    }

    return (_sortedEmotePackages$ = _findInstanceProperty(sortedEmotePackages).call(sortedEmotePackages, function (pkg) {
      return pkg.id === activeEmotePackageId;
    })) !== null && _sortedEmotePackages$ !== void 0 ? _sortedEmotePackages$ : sortedEmotePackages[0];
  }, [activeEmotePackageId, sortedEmotePackages]);

  var handleClickOutsidePanel = function handleClickOutsidePanel(e) {
    var _props$onClose;

    if (!rootRef.current) {
      return;
    }

    if (e.target instanceof Node && rootRef.current.contains(e.target)) {
      return;
    }

    (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props, e);
  };

  useEvent('click', handleClickOutsidePanel);

  if (!currentUser) {
    return null;
  }

  var handleOnSelect = function handleOnSelect(emote) {
    var _props$onSelect;

    (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 ? void 0 : _props$onSelect.call(props, emote);
  };

  var handleSwitchPackage = function handleSwitchPackage(nextPackageId) {
    setActiveEmotePackageId(nextPackageId);
    recordLastUsedPackage(currentUser.id, nextPackageId);
  };

  var renderInner = function renderInner() {
    var EmotesPicker = emoteListMap[activeEmotePackage.type];
    var locked = emotePackagesState[activeEmotePackage.id] === EPackageState.Locked;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "emote-package-title"
    }, activeEmotePackage.text), /*#__PURE__*/React__default.createElement(Scrollable, {
      className: classNames('emotes-picker-container', {
        locked: locked
      })
    }, locked && /*#__PURE__*/React__default.createElement("div", {
      className: "lock-overlay"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "lock-inner"
    }, !!activeEmotePackage.cover_url && /*#__PURE__*/React__default.createElement(SquareLazyImage, {
      className: "icon",
      src: appendEmotePrefix(activeEmotePackage.cover_url),
      alt: activeEmotePackage.text
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "lock-info"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "package-title"
    }, activeEmotePackage.text), !!activeEmotePackage.lockTips &&
    /*#__PURE__*/

    /* eslint-disable-next-line @typescript-eslint/naming-convention */
    React__default.createElement("div", {
      className: "description",
      dangerouslySetInnerHTML: {
        __html: activeEmotePackage.lockTips
      }
    })))), /*#__PURE__*/React__default.createElement(EmotesPicker, {
      emotes: activeEmotePackage.emote,
      onSelect: handleOnSelect
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "emote-package-picker"
    }, _mapInstanceProperty(sortedEmotePackages).call(sortedEmotePackages, function (emotePackage) {
      return /*#__PURE__*/React__default.createElement("img", {
        key: emotePackage.id,
        className: classNames('icon', {
          active: emotePackage.id === activeEmotePackage.id
        }),
        src: emotePackage.image_url,
        onClick: function onClick() {
          handleSwitchPackage(emotePackage.id);
        }
      });
    })));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    ref: rootRef,
    className: classNames('emote-panel', className)
  }, sortedEmotePackages.length > 0 ? renderInner() : /*#__PURE__*/React__default.createElement("div", {
    className: "error-message"
  }, "\u54CE\u5440\u51FA\u9519\u4E86 ", /*#__PURE__*/React__default.createElement("span", null, ">_<")));
};

export { EmotePanel };
